export default __webpack_public_path__ + "static/media/application-banner-img-01.cd504403.jpg";